(() => {
  const form = document.querySelector('[data-delivery-quote-form]');
  const message = form?.querySelector('[data-contact-message]');
  const params = new URLSearchParams(window.location.search);
  const product = params.get('product');

  if (!message || !product || message.value.trim()) return;

  const variant = params.get('variant');
  const productUrl = params.get('product_url');
  const lines = ['Freight quote request', `Product: ${product}`];

  if (variant) lines.push(`Selected option: ${variant}`);
  if (productUrl) lines.push(`Product page: ${productUrl}`);

  message.value = `${lines.join('\n')}\n\n`;
})();
